export const PYLON_APP_ID = '23a10b31-0635-4200-bc8b-de00df01e68d';
export const PYLON_WIDGET_URL = `https://widget.usepylon.com/widget/${PYLON_APP_ID}`;
